<script>
import ModalSelectCareerComponent from '../../features/modals/ModalSelectCareerComponent';

export default {
  name: 'ModalSelectCareerView',
  extends: ModalSelectCareerComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Educación"
      width="60%"
      class="select-careers-modal"
      :before-close="onCancel"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Información de Educativa</legend>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24"
            >
              <el-form-item
                label="Universidad"
                prop="university"
              >
                <el-select
                  v-model="formData.university"
                  allow-create
                  clearable
                  filterable
                  remote
                  :remote-method="onFindUniversity"
                  placeholder="Seleccionar"
                  value-key="id"
                  size="small"
                  @change="onSelectUniversity"
                >
                  <el-option
                    v-for="item in universities"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24"
            >
              <p>Áreas de Conocimiento</p>
            </el-col>
            <el-col
              :xs="6"
              :sm="6"
              :md="6"
              :lg="24"
              :xl="24"
            >
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
              >
                Marcar todos
              </el-checkbox>
              <div style="margin: 15px 0" />
              <el-checkbox-group
                v-model="checkedKnowledgeAreas"
                @change="handleCheckedKnowledgeAreasChange"
              >
                <el-checkbox
                  v-for="knowledgeArea in knowledgeAreas"
                  :key="knowledgeArea.id"
                  :value="knowledgeArea.id"
                >
                  {{ knowledgeArea.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24"
              align="right"
            >
              <el-button-group>
                <el-button
                  type="primary"
                  class="btn-primary"
                  size="small"
                  @click="onFindAllCareersByKnowledgeAreaIds"
                >
                  Buscar
                </el-button>
                <el-button
                  size="small"
                  class="btn-cancel"
                  @click="clearSelection()"
                >
                  Limpiar
                </el-button>
              </el-button-group>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24"
            >
              <el-table
                ref="multipleTable"
                :data="collection"
                width="100%"
                max-height="300"
                @selection-change="handleSelectionChange"
              >
                >
                <el-table-column
                  type="selection"
                  width="55"
                />
                <el-table-column
                  prop="name"
                  label="Carrera"
                  min-width="300"
                />
                <el-table-column
                  label="Área"
                  min-width="300"
                >
                  <template #default="scope">
                    <div>
                      {{ scope.row.knowledgeArea.name }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Universidad"
                  min-width="300"
                >
                  <template #default="scope">
                    <div>
                      {{ scope.row.university.name }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </fieldset>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Aceptar</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
